import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { supabaseAdmin } from "@/integrations/supabase/client.server";

const ContactInput = z.object({
  name: z.string().min(1).max(120),
  email: z.string().email().max(254),
  message: z.string().min(10).max(5000),
  budget: z.string().max(60).optional().nullable(),
});

export const submitContact = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) => ContactInput.parse(input))
  .handler(async ({ data }) => {
    const { error } = await (supabaseAdmin.from("contact_submissions") as any).insert({
      name: data.name,
      email: data.email,
      message: data.message,
      budget: data.budget || null,
    });
    if (error) {
      throw new Error("Could not save your message. Try again or email jon@vibing.inc.");
    }
    return { ok: true };
  });
